import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { VideoCameraFilled } from "@ant-design/icons";

const NavegadorArriendos = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const { rex_data_permissions_user } = useSelector(({ loginGrow }) => loginGrow);

  // Obtiene el país actual del usuario desde localStorage
  const currentCountryId = parseInt(localStorage.getItem('usupais'));

  // Verifica si existe el permiso 'peru.arriendos' y si el país actual es Perú (paiid = 1)
  const hasArriendosPermission = rex_data_permissions_user?.some((perm) => perm.pemslug === "peru.arriendos");
  const isCurrentCountryPeru = currentCountryId === 1;


  return (
    <>
      <div className="navigation-container">
        <nav className="nav-links">
          {hasArriendosPermission && isCurrentCountryPeru && (
            <>
              <Link to="/status" className={`nav-link ${pathname === "/status" ? "active" : ""}`}>
                Status
              </Link>
            </>
          )}
          <Link to="/file-upload" className={`nav-link ${pathname === "/file-upload" ? "active" : ""}`}>
            File Upload
          </Link>
          <Link to="/download-data" className={`nav-link ${pathname === "/download-data" ? "active" : ""}`}>
            Download File
          </Link>
          {hasArriendosPermission && isCurrentCountryPeru && (
            <>
              <Link to="/video-arriendo" className={`nav-link ${pathname === "/video-arriendo" ? "active" : ""}`}>
                <VideoCameraFilled style={{ "marginRight": "5px" }} />Tutoriales
              </Link>
            </>
          )}
        </nav>

        <style jsx="true">{`
          .navigation-container {
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
            max-width: 800px;
            margin: 0 auto;
            padding: 2px 20px;
          }

          .nav-links {
            display: flex;
            justify-content: space-between;
            gap: 10px;
            width: 100%;
            background-color: #f5f5f5;
            border-radius: 40px;
            padding: 2px 5px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
          }

          .nav-link {
            padding: 8px 13px;
            border-radius: 30px;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s ease;
            text-align: center;
            color: #555;
            text-decoration: none;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .nav-link:hover {
            background-color: rgba(0, 0, 0, 0.05);
          }

          .nav-link.active {
            background-color: #3b72ff;
            color: white;
            box-shadow: 0 4px 12px rgba(33, 150, 243, 0.3);
          }
        `}</style>
      </div>
    </>
  );
};

export default NavegadorArriendos;